const configsPages = {
  pages: {
    type: 'page',
    content: {
      // About Pages.
      about: {
        id: 'about',
      },
      privacypolicy: {
        id: 'privacy-policy',
      },
      termsofuse: {
        id: 'terms-of-use',
      },
      partners: {
        id: 'partners',
      },
    },
  },
}

export default configsPages
